import { Button } from 'antd';
import { Plus, ShieldAlert } from 'lucide-react';
import { useState } from 'react';
import { Navigate } from 'react-router';
import { EmptyState } from '../../../../../shared/components/EmptyState';
import { TableSkeleton } from '../../../../../shared/components/TableSkeleton';
import { buildTruckColumns } from '../components/build-truck-columns';
import { CreateTruckDrawer } from '../components/CreateTruckDrawer';
import { TrucksTable } from '../components/TrucksTable';
import { useTruckCatalogues } from '../hooks/use-truck-catalogues';
import { useTrucks } from '../hooks/use-trucks';

export function TrucksPage() {
  const { state, list, isRefreshing, createError, creating, create, resetCreateError } = useTrucks();
  const catalogues = useTruckCatalogues();
  const [drawerOpen, setDrawerOpen] = useState(false);

  if (state.status === 'forbidden') return <Navigate to="/" replace />;

  const truckClasses = catalogues.status === 'loaded' ? catalogues.truckClasses : [];
  const columns = buildTruckColumns({ list, classOptions: truckClasses.map((c) => ({ text: c.name, value: c.code })) });

  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-end">
        <Button
          type="primary"
          icon={<Plus className="size-4" />}
          onClick={() => {
            resetCreateError();
            setDrawerOpen(true);
          }}
        >
          Create truck
        </Button>
      </div>
      {state.status === 'error' && (
        <EmptyState icon={ShieldAlert} title="Couldn't load trucks" description="Something went wrong loading the trucks list. Try reloading the page." />
      )}
      {state.status === 'loading' && <TableSkeleton label="Loading trucks" withSearch />}
      {state.status === 'loaded' && <TrucksTable page={state.page} columns={columns} list={list} isRefreshing={isRefreshing} />}
      <CreateTruckDrawer
        open={drawerOpen}
        truckClasses={truckClasses}
        error={createError}
        submitting={creating}
        onCreate={create}
        onClose={() => setDrawerOpen(false)}
      />
    </div>
  );
}
